﻿import * as Repositories from './repositories';
export default angular.module('idi.marketplace.repositories', ['core'])
    .service('submissionRepository', Repositories.SubmissionRepository)
    .service('phoneRepository', Repositories.PhoneRepository)
    .service('policyholderRepository', Repositories.PolicyholderRepository)
    .service('addressRepository', Repositories.AddressRepository)
    .service('codeRepository', Repositories.CodeRepository)
    .service('locationRepository', Repositories.LocationRepository)
    .service('questionRepository', Repositories.QuestionRepository)
    .service('questionResponseRepository', Repositories.QuestionResponseRepository)
    .service('policyholderuserRepository', Repositories.PolicyholderUserRepository)
    .service('vehicleRepository', Repositories.VehicleRepository)
    .service('billingStatementRepository', Repositories.BillingStatementRepository)
    .service('userRepository', Repositories.UserRepository)
    .service('paymentRepository', Repositories.PaymentRepository)
    .service('policyRepository', Repositories.PolicyRepository)
    .service('policysummaryRepository', Repositories.PolicySummaryRepository)
    .service('lineOfBusinessRatingFactorsRepository', Repositories.LineOfBusinessRatingFactorsRepository)
    .service('tokenRequestRepository', Repositories.TokenRequestRepository)
    .service('eventLogRepository', Repositories.EventLogRepository)
    .service('submissionRequestRepository', Repositories.SubmissionRequestRepository)
    .service('brandRepository', Repositories.BrandRepository)
    .service('verticalRepository', Repositories.VerticalRepository)
    .name;